import { Modal, Box, TextField, MenuItem, Button, Typography, CardContent, Card, Grid, Paper } from '@mui/material'
import { useState, useEffect } from 'react'

//MUI ICON
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import ReceiptIcon from '@mui/icons-material/Receipt';
import EditIcon from '@mui/icons-material/Edit';

//Custom Hooks
import useFetchWasteFee from '../hooks/useFetchWasteFee';
import WastefeeReceiptAddModal from './WastefeeReceiptAddModal';
import ReceiptView from './ReceiptView';

// Custom Component
import BackDropLoading from '../../Layouts/BackDropLoading';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65vw',
    height: 'auto',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    overflow: 'auto',
    p: 4,
    '& .MuiTextField-root': { m: 1 }
};
export default function WasteFeePaymentEditModal(props) {
    const { monthPaymentStatus, setMonthPaymentStatus, editPaymentModalOpen, setEditPaymentModalOpen, rowId,
        setRowId, setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText, yearPayment, setYearPayment
    } = props
    //CustomHooks
    const { fetchPaymentData, fetchReceipt, fetchEditReceipt } = useFetchWasteFee()
    // 
    // useState
    const [backDropLoading, setBackDropLoading] = useState(false)
    const currentBudgetYear = 2568
    const [monthNo, setMonthNo] = useState('')
    const [budgetYear, setBudgetYear] = useState(currentBudgetYear)
    function setDefaultWasteFeePaymentData() {
    }
    // Add Receipt
    const [addReceiptModalOpen, setAddReceiptModalOpen] = useState(false)
    const [addReceiptData, setAddReceiptData] = useState({
        receiptNo: '',
        totalFee: '',
        receiptDate: null,
        note: ''
    })
    function setDefaultAddReceiptData() {
        setAddReceiptData({
            receiptNo: '',
            totalFee: '',
            receiptDate: null,
            note: ''
        })
    }
    //
    // Receipt View
    const [receiptViewModalOpen, setReceiptViewModalOpen] = useState(false)
    const [receiptViewData, setReceiptViewData] = useState({
        receiptNo: '',
        totalFee: '',
        receiptDate: '',
        note: ''
    })
    //


    // useEffect(() => {
    //     console.log(addReceiptData.id)
    // }, [addReceiptData])
    return (
        <Modal
            open={editPaymentModalOpen}
            onClose={() => {
                setEditPaymentModalOpen(false)
                setBudgetYear(currentBudgetYear)
                setRowId(undefined)
                setDefaultWasteFeePaymentData()
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={style}
            // component='form'
            // onSubmit={(event) => {
            //     event.preventDefault()
            //     fetchPaymentDataEdit(rowId, budgetYear, monthPaymentStatus, monthPaymentBillNo, setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText)
            //     setEditPaymentModalOpen(false)
            // }
            // }
            >
                <Card
                // sx={{ width: '88ch' }}
                >
                    <Typography
                        variant='h5' sx={{ m: 1 }}>การชำระเงิน</Typography >
                    <CardContent>
                        <TextField
                            sx={{ width: '15ch' }}
                            select
                            label='ปีงบประมาณ'
                            value={budgetYear}
                            onChange={async (event) => {
                                setBackDropLoading(true)
                                await fetchPaymentData(rowId, event.target.value, monthPaymentStatus, setMonthPaymentStatus, setYearPayment)
                                setBudgetYear(event.target.value)
                                setBackDropLoading(false)
                            }}
                        >
                            <MenuItem value={2568}>2568</MenuItem>
                            <MenuItem value={2569}>2569</MenuItem>
                            <MenuItem value={2570}>2570</MenuItem>
                            <MenuItem value={2571}>2571</MenuItem>
                            <MenuItem value={2572}>2572</MenuItem>
                            <MenuItem value={2573}>2573</MenuItem>
                            <MenuItem value={2574}>2574</MenuItem>
                            <MenuItem value={2575}>2575</MenuItem>
                            <MenuItem value={2576}>2576</MenuItem>
                            <MenuItem value={2577}>2577</MenuItem>
                        </TextField>
                        {yearPayment ?
                            <Button
                                sx={{ m: 1 }}
                                variant='contained'
                                startIcon={<CheckCircleOutlineIcon />}
                                onClick={() => {
                                    setDefaultAddReceiptData()
                                    setMonthNo('')
                                    setAddReceiptModalOpen(true)
                                }}
                            >
                                ชำระทั้งปี
                            </Button>
                            : ''
                        }
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={2}>
                            {monthPaymentStatus.map((month, index) => (
                                <Grid item key={index} xs={12} sm={6} md={3}>
                                    <Paper elevation={2} sx={{ p: 1 }}
                                    >
                                        <Typography variant="h6">{month.month} </Typography>
                                        <Typography variant="body1" color={month?.paid ? "success" : "error"}>{month?.paid ? 'ชำระแล้ว' : 'ยังไม่ชำระ'}</Typography>
                                        {month?.paid ?
                                            <Box>
                                                <Button
                                                    sx={{ m: 1 }}
                                                    variant='contained'
                                                    color='success'
                                                    startIcon={<ReceiptIcon />}
                                                    onClick={() => {
                                                        fetchReceipt(rowId, month.monthNo, setReceiptViewData)
                                                        setReceiptViewModalOpen(true)
                                                    }}
                                                >
                                                    แสดงข้อมูลใบเสร็จ
                                                </Button>
                                                <Button
                                                    sx={{ m: 1 }}
                                                    variant='contained'
                                                    color='warning'
                                                    startIcon={<EditIcon />}
                                                    onClick={async () => {
                                                        setDefaultAddReceiptData()
                                                        setMonthNo(month.monthNo)
                                                        await fetchEditReceipt(rowId, month.monthNo, addReceiptData, setAddReceiptData)
                                                        setAddReceiptModalOpen(true)
                                                    }}
                                                >
                                                    แก้ไข
                                                </Button>
                                            </Box>
                                            : <Button
                                                sx={{ m: 1 }}
                                                variant='contained'
                                                startIcon={<SaveIcon />}
                                                onClick={() => {
                                                    setDefaultAddReceiptData()
                                                    setMonthNo(month.monthNo)
                                                    setAddReceiptModalOpen(true)
                                                }}
                                            >
                                                บันทึกข้อมูลใบเสร็จ
                                            </Button>
                                        }
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
                <WastefeeReceiptAddModal
                    addReceiptModalOpen={addReceiptModalOpen}
                    setAddReceiptModalOpen={setAddReceiptModalOpen}
                    addReceiptData={addReceiptData}
                    setAddReceiptData={setAddReceiptData}
                    rowId={rowId}
                    budgetYear={budgetYear}
                    monthNo={monthNo}
                    monthPaymentStatus={monthPaymentStatus}
                    setMonthPaymentStatus={setMonthPaymentStatus}
                    setEditPaymentModalOpen={setEditPaymentModalOpen}
                    setSuccessAlertOpen={setSuccessAlertOpen}
                    setSuccessText={setSuccessText}
                    setErrorAlertOpen={setErrorAlertOpen}
                    setErrorText={setErrorText}
                    setDefaultAddReceiptData={setDefaultAddReceiptData}
                    setYearPayment={setYearPayment}
                />
                <ReceiptView
                    receiptViewModalOpen={receiptViewModalOpen}
                    setReceiptViewModalOpen={setReceiptViewModalOpen}
                    receiptViewData={receiptViewData}
                />
                <BackDropLoading backDropLoading={backDropLoading} />
            </Box>
        </Modal>
    )
}
